import React, { useState } from "react";
import { useData } from "@/context/DataContext";
import { PageTitle, Fab, RowActions, EmptyState } from "@/components/shared";
import DataDialog from "@/components/DataDialog";
import { formatRupiah } from "@/lib/format";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Checkbox } from "@/components/ui/checkbox";
import { toast } from "sonner";

export default function Dokumen() {
  const { data, create, update, remove } = useData();
  const items = data.dokumen || [];
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  const fields = [
    { name: "nama", label: "Nama Dokumen", type: "text", required: true },
    { name: "detail", label: "Detail", type: "textarea" },
    { name: "qty", label: "Qty", type: "text" },
    { name: "harga", label: "Harga", type: "currency" },
  ];

  const onSave = async (payload) => {
    if (editing) { await update("dokumen", editing.id, payload); toast.success("Diperbarui"); }
    else { await create("dokumen", { ...payload, done: false }); toast.success("Ditambahkan"); }
  };

  return (
    <div>
      <PageTitle title="List Dokumen" subtitle="Ceklist kelengkapan dokumen pernikahan" />
      <div className="rounded-xl border border-border">
        <Table>
          <TableHeader><TableRow>
            <TableHead className="w-10"></TableHead><TableHead>Nama Dokumen</TableHead><TableHead>Detail</TableHead>
            <TableHead>Qty</TableHead><TableHead className="text-right">Harga</TableHead><TableHead className="text-right">Aksi</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {items.map((i) => (
              <TableRow key={i.id} data-testid={`row-${i.id}`} className={i.done ? "bg-green-500/15" : ""}>
                <TableCell><Checkbox data-testid={`check-${i.id}`} checked={!!i.done} onCheckedChange={(v) => update("dokumen", i.id, { done: !!v })} /></TableCell>
                <TableCell className="font-medium">{i.nama}</TableCell>
                <TableCell className="max-w-[200px] truncate text-muted-foreground">{i.detail || "-"}</TableCell>
                <TableCell>{i.qty || "-"}</TableCell>
                <TableCell className="text-right">{i.harga ? formatRupiah(i.harga) : "-"}</TableCell>
                <TableCell><RowActions id={i.id} onEdit={() => { setEditing(i); setOpen(true); }} onDelete={() => remove("dokumen", i.id)} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {items.length === 0 && <EmptyState />}
      </div>
      <Fab testId="fab-dokumen" onClick={() => { setEditing(null); setOpen(true); }} />
      <DataDialog open={open} onOpenChange={setOpen} title={editing ? "Edit Dokumen" : "Tambah Dokumen"} fields={fields} initial={editing} onSave={onSave} />
    </div>
  );
}
